export const STATE_NAME = 'favoriteListings';
